import React from "react";
import { OpenStatusDispensary } from "components/Dispensary/OpenStatus";
import { Dispensary } from "custom-types/Dispensary";
import { useSelector } from "react-redux";
import { getLocalizedDistanceAnyDispensary } from "redux/selectors/dispensaryHelper";
import { getCountryCode, getUserLocation } from "redux/selectors/location";

type DispensaryInformationProps = {
  dispensary: Dispensary;
};

export const DispensaryInformation: React.FC<DispensaryInformationProps> = ({
  children,
  dispensary,
}) => {
  const countryCode = useSelector(getCountryCode);
  const location = useSelector(getUserLocation);
  const { full: localizedDistance } = getLocalizedDistanceAnyDispensary(
    countryCode,
    dispensary,
    location
  );

  return (
    <div className="rounded bg-green-20 p-md pt-sm text-xs mt-xl">
      <div className="font-bold">{dispensary?.name}</div>
      {children}
      <div>
        <OpenStatusDispensary
          className="inline-block"
          dispensary={dispensary}
        />
        {(localizedDistance || "").length > 0 && (
          <>
            <span className="mr-md ml-sm">|</span>
            <span className="text-green font-bold">{localizedDistance}</span>
          </>
        )}
      </div>
    </div>
  );
};
